module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n.form-control{\r\n    width:150px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/promotion-list-authorization/pro-list-auth/pro-list-auth.component.css
// module id = ./src/app/hrms/Promotions/promotion-list-authorization/pro-list-auth/pro-list-auth.component.css
// module chunks = main